// src/utils/date.ts

export function toDateOnly(dateString: string): string {
	if (!dateString) return "";
	const date = new Date(dateString);
	return date.toISOString().slice(0, 10);
}

export function formatUTCDateTime(utcDateTime: string): string {
	if (!utcDateTime.includes("Z") && !utcDateTime.match(/[+-]\d{2}:\d{2}$/)) {
		utcDateTime += "Z"; // Add 'Z' to treat it as UTC
	}

	const date = new Date(utcDateTime);

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");

	let hours = date.getHours();
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const ampm = hours >= 12 ? "pm" : "am";

	hours %= 12;
	hours = hours || 12; // the hour '0' should be '12'

	return `${year}-${month}-${day}, ${hours}:${minutes}${ampm}`;
}

function parseUtc(dateTime: string): Date {
	let utcDateTime = dateTime;
	if (!utcDateTime.includes("Z") && !utcDateTime.match(/[+-]\d{2}:\d{2}$/)) {
		utcDateTime += "Z";
	}
	return new Date(utcDateTime);
}

/**
 * Whole hours remaining until a deadline supplied by the backend (0 if passed or missing)
 * @param deadline - ISO timestamp, e.g. an Inner Circle win's claim_expires_at
 */
export function hoursUntil(deadline: string | null | undefined): number {
	if (!deadline) return 0;

	const timeDifference = parseUtc(deadline).getTime() - Date.now();
	return Math.max(0, Math.floor(timeDifference / (1000 * 60 * 60)));
}

/**
 * Whether a backend-supplied deadline is still in the future (false if missing)
 */
export function isBeforeDeadline(deadline: string | null | undefined): boolean {
	return !!deadline && parseUtc(deadline).getTime() > Date.now();
}

export function hoursSinceTime(
	utcDateTime: string,
	hours: number = 24
): boolean {
	if (!utcDateTime.includes("Z") && !utcDateTime.match(/[+-]\d{2}:\d{2}$/)) {
		utcDateTime += "Z"; // Add 'Z' to treat it as UTC
	}

	const givenTime = new Date(utcDateTime);
	const currentTime = new Date();

	const timeDifference = currentTime.getTime() - givenTime.getTime();
	const hoursDifference = timeDifference / (1000 * 60 * 60);

	return hoursDifference < hours;
}
